export default function InvalidText({ name }) {
  return (
    <span className="col small form-text text-danger">
      {name} tidak boleh kosong.
    </span>
  )
}
